import useCategories from "../../hooks/useCategories";
import { businessInitials, userColor } from "../../utils/userUtils";
import classNames from "classnames";

export default function BusinessToggle({ business, role, disabled, setSelectedBusiness, selectedBusiness }) {

  const { data: categories } = useCategories({ businessId: business.id, staleTime: 10000 });

  if (!categories) {
    return;
  }

  const toggledCategories = categories.reduce((acc, cur) => acc + (role.category_ids.includes(cur.id) ? 1 : 0), 0);

  return (
    <button key={business.id} disabled={disabled} className={classNames("business-select", { selected: business.id === selectedBusiness })} onClick={() => setSelectedBusiness(business.id)}>
      <div className="business-logo" style={{ backgroundColor: userColor(business).code }}><span>{ businessInitials(business.name) }</span></div>
      <div className="business-name">{ business.name }</div>
      { toggledCategories > 0 && <div className="toggled-categories">{ toggledCategories }</div> }
    </button>
  );
}
